<script setup lang="ts">
import DraggerMenuState from "@/stores/DraggerMenuState";
import type { Arrayable } from "@vueuse/core";

function setSize(value: Arrayable<number>) {
  if (typeof value === "number") {
    DraggerMenuState.setEraserSize(value);
  }
}
</script>

<template>
  <div class="rounded py-3 d-flex flex-column align-items-center">
    <div class="text-white">
      {{ $t("canvas:tools.options.eraser.size.title") }}
    </div>
    <div class="d-flex">
      <el-slider
        :model-value="DraggerMenuState.eraserSize"
        @input="(v) => setSize(v)"
        height="150px"
        vertical
        :step="10"
        :min="0"
        :max="100"
      />
    </div>
  </div>
</template>
